import React from 'react';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Ana Laura G.',
  city: 'Bogotá',
  text: 'Por fin el chicharrón me quedó crocante y no como un caucho. El truco del golpe de calor al final es la magia. ¡Recomendadísimo!',
  rating: 5
}, {
  name: 'María Fernanda P.',
  city: 'Medellín',
  text: 'Yo solo usaba la airfryer para calentar pan. Ayer hice patacones y mi esposo no podía creer que no tenían aceite. Vale cada peso.',
  rating: 5
}, {
  name: 'Carolina R.',
  city: 'Cali',
  text: 'Lo mejor es la tabla de tiempos para las marcas de acá. Yo tengo una Imusa y los tiempos de internet nunca me servían. Con esto, perfecto a la primera.',
  rating: 5
}, {
  name: 'Diana M.',
  city: 'Barranquilla',
  text: 'Compré por el bono de recetas ligeras y terminé amando todo. Cocino en 15 minutos y la cocina no queda oliendo a frito por días.',
  rating: 4
}, {
  name: 'Valentina C.',
  city: 'Bucaramanga',
  text: 'Las arepas de queso quedan doraditas por fuera y derretidas por dentro. El sistema de dos pasos funciona de verdad.',
  rating: 5
}, {
  name: 'Juliana S.',
  city: 'Pereira',
  text: 'Estaba a punto de regalar mi airfryer porque todo me quedaba seco. Este libro me salvó. El truco de limpieza también es un hit.',
  rating: 5
}];
export function TestimonialsSection() {
  return <section className="py-16 md:py-24 bg-warm-50 overflow-hidden" data-id="element-243">
      <div className="max-w-6xl mx-auto px-4 mb-12 text-center" data-id="element-244">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-charcoal mb-4" data-id="element-245">
          Lo que dicen las colombianas que ya lo probaron
        </h2>
        <p className="text-charcoal-muted" data-id="element-246">
          Resultados reales aplicando el Mecanismo de Fuego Criollo.
        </p>
      </div>

      {/* Infinite Scroll Container */}
      <div className="relative w-full overflow-hidden flex" data-id="element-247">
        {/* Marquee Track */}
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]" data-id="element-248">
          {/* Group 1 */}
          <div className="flex gap-6 px-3" data-id="element-249">
            {TESTIMONIALS.map((t, i) => <TestimonialCard key={`t1-${i}`} {...t} data-id="element-250" />)}
          </div>
          {/* Group 2 (Duplicate for seamless loop) */}
          <div className="flex gap-6 px-3" data-id="element-251">
            {TESTIMONIALS.map((t, i) => <TestimonialCard key={`t2-${i}`} {...t} data-id="element-252" />)}
          </div>
        </div>
      </div>

      <div className="text-center mt-10" data-id="element-253">
        <p className="text-xs text-charcoal-muted" data-id="element-254">
          * Resultados pueden variar según el modelo de Airfryer y seguimiento
          de instrucciones.
        </p>
      </div>

      <style data-id="element-255">{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
      `}</style>
    </section>;
}
function TestimonialCard({
  name,
  city,
  text,
  rating
}: {
  name: string;
  city: string;
  text: string;
  rating: number;
}) {
  return <div className="bg-white p-6 rounded-2xl shadow-md border border-warm-100 w-[300px] md:w-[350px] shrink-0 whitespace-normal flex flex-col" data-id="element-256">
      <div className="flex items-center gap-1 mb-4" data-id="element-257">
        {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < rating ? 'fill-accent text-accent' : 'fill-gray-200 text-gray-200'}`} data-id="element-258" />)}
      </div>
      <p className="text-charcoal font-medium mb-6 text-sm italic leading-relaxed flex-1" data-id="element-259">
        "{text}"
      </p>
      <div className="flex items-center gap-3 mt-auto pt-4 border-t border-warm-50" data-id="element-260">
        <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center text-primary font-bold font-heading" data-id="element-261">
          {name.charAt(0)}
        </div>
        <div data-id="element-262">
          <p className="font-bold text-charcoal text-sm" data-id="element-263">{name}</p>
          <p className="text-xs text-charcoal-muted" data-id="element-264">{city}</p>
        </div>
      </div>
    </div>;
}